import { z } from 'zod';
import { PRODUCT_NEWS_CATEGORIES } from '../constants/index.js';
import { isoDateTimeSchema } from './common.js';
import { paginationMetaSchema } from './pagination.js';
import { supportedLocaleSchema } from './plm-material.js';
export const productNewsCategorySchema = z.enum(PRODUCT_NEWS_CATEGORIES);
export const productNewsListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(50).default(50),
    category: productNewsCategorySchema.optional(),
    locale: supportedLocaleSchema.optional(),
});
export const productNewsEntrySchema = z.object({
    id: z.string().min(1).max(100),
    version: z.string().min(1).max(30),
    publishedAt: isoDateTimeSchema,
    category: productNewsCategorySchema,
    title: z.string().min(1).max(200),
    description: z.string().min(1).max(1_000),
    linkUrl: z.string().startsWith('/'),
    isUnread: z.boolean(),
});
export const productNewsListResponseSchema = z.object({
    data: z.array(productNewsEntrySchema),
    meta: paginationMetaSchema,
    unreadCount: z.number().int().min(0),
    lastReadEntryId: z.string().nullable(),
});
export const productNewsUnreadCountSchema = z.object({
    unreadCount: z.number().int().min(0),
});
export const productNewsMarkReadRequestSchema = z.object({
    entryId: z.string().min(1).max(100),
});
export const productNewsMarkReadResponseSchema = z.object({
    lastReadEntryId: z.string(),
    unreadCount: z.number().int().min(0),
});
//# sourceMappingURL=product-news.js.map